<div class="root">
  <img class="cover" (click)="playTrack(track)" [src]="track.cover" [alt]="track.title" />
  <div
    *ngIf="trackPlaying(track, currentTrackPlaying$ | async, isPlaying$ | async)"
    class="pause-container"
  >
    <mat-icon fontSet="fa" fontIcon="fa-pause"></mat-icon>
  </div>
  <div (click)="openTrackDetails(track)">
    <div class="title-artist">
      <div class="title ellipsis">{{ track.title }}</div>
      <div class="artist ellipsis">{{ track.artist }}</div>
    </div>
    <div class="duration">
      {{ track.timeSeconds ? (track.timeSeconds | timeFormat) : '' }}
    </div>
  </div>
</div>
